<template>
  <div class="th-notification-header d-flex justify-content-between align-items-center mt-15">
    <div>
      <span class="manage-tags-text d-block mb-5">{{ activityName }}</span>
      <span class="manage-tags-description">{{ description }}</span>
    </div>
    <div class="col-md-5 pr-0 d-flex justify-content-between">
      <slot name="searchNotification" />
      <div>
        <button class="tags-page__header__add-tag-btn btn" @click="$emit('addNotification')">
          <span class="square">+</span>
          <span class="tag-span pl-10">Add Notifications</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    description: String,
    activityName: String
  }
};
</script>
<style lang="scss" scoped>
.th-notification-header {
  margin: 100px auto 0 auto;
  .tags-page__header__add-tag-btn {
    width: 167px;
    display: flex;
    align-items: center;
    height: 35px;
    border-radius: 4px;
    background-color: #4c8ce4;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    color: #ffffff;
    padding: 4px 12px 4px 3px;
  }
  .manage-tags-text {
    height: 24px;
    font-family: "RobotoRegular";
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: #000000;
  }

  .manage-tags-description {
    font-family: "RobotoRegular";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: normal;
    color: #000000;
  }
}
.square {
  width: 29px;
  height: 27px;
  background-color: #fff;
  position: relative;
  color: #4c8ce4;
  font-weight: normal;
  border-radius: 3px;
  font-size: 22px;
}
</style>
